const state = {
    activeIndex: sessionStorage.getItem("activeIndex") || "/",
    language: sessionStorage.getItem("lang") || 'cn',
    darkMode: true
}

const mutations = {
    SET_ACTIVE(state, str) {
        state.activeIndex = str;
    },
    SET_LANGUAGE(state, val) {
        state.language = val;
    },
    SET_DARKMODE(state, bool) {
        state.darkMode = bool
    }
}

const actions = {
    // setFooter({ commit }, bool) {
    //     commit('SET_FOOTER', bool)
    // }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}